import { render, staticRenderFns } from "./OrderAdmittanceProlongation.vue?vue&type=template&id=f8fc48c6&scoped=true&"
import script from "./OrderAdmittanceProlongation.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceProlongation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fc48c6",
  null
  
)

export default component.exports
import {QItem,QInput,QBtn,QTooltip,QTable,QTr,QTh,QTd,QDialog} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QBtn,QTooltip,QTable,QTr,QTh,QTd,QDialog}, component.options.components || {})
